import ajax from '@ep/tools/ajax';
import { createAuthClient } from '@ep/auth-client/index.js';

const authClient = createAuthClient(ajax);

export default authClient;
